<div
  class="account-menu"
  [class.account-menu--open]="isOpen()"
  (outsideClick)="closeMenu()"
>
  <button
    type="button"
    class="account-menu__trigger"
    (click)="toggleMenu()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="menu"
  >
    <span class="account-menu__trigger-avatar">
      <img
        [src]="user.avatar_url() || 'assets/images/placeholders/user_placeholder.png'"
        [alt]="accountName() || 'User avatar'"
      />
    </span>
    <span class="account-menu__trigger-name">{{ accountName() }}</span>
  </button>

  <div
    class="account-menu__dropdown-shell"
    [class.account-menu__dropdown-shell--open]="isOpen()"
  >
    <div class="account-menu__dropdown">
      <img
        class="account-menu__brand-logo"
        src="assets/images/Logo.png"
        alt="QForm Global ID"
      />

      <div class="account-menu__profile">
        <img
          class="account-menu__profile-avatar"
          [src]="user.avatar_url() || 'assets/images/placeholders/user_placeholder.png'"
          [alt]="accountName() || 'User avatar'"
        />
        <div class="account-menu__profile-name" [matTooltip]="accountName()">{{ accountName() }}</div>
      </div>

      <nav class="account-menu__nav" aria-label="Account menu">
        <button
          type="button"
          class="account-menu__item"
          matRipple
          (click)="navigateTo('profile')"
        >
          <app-icon-account [color]="'#828282'"></app-icon-account>
          <span>{{ 'menu.profile' | translate }}</span>
        </button>
        <button
          type="button"
          class="account-menu__item"
          matRipple
          (click)="navigateTo('answer')"
        >
          <app-icon-answer [color]="'#828282'"></app-icon-answer>
          <span>{{ 'menu.answer' | translate }}</span>
        </button>
        <button
          type="button"
          class="account-menu__item"
          matRipple
          (click)="navigateTo('favorite-form')"
        >
          <app-icon-favorite [color]="'#828282'"></app-icon-favorite>
          <span>{{ 'menu.favorite' | translate }}</span>
        </button>
        <button
          type="button"
          class="account-menu__item"
          matRipple
          (click)="navigateTo('draft')"
        >
          <app-icon-draft [color]="'#828282'"></app-icon-draft>
          <span>{{ 'menu.draft' | translate }}</span>
        </button>
        <button
          type="button"
          class="account-menu__item"
          matRipple
          (click)="navigateTo('logout')"
        >
          <app-icon-logout [color]="'#828282'"></app-icon-logout>
          <span>{{ 'menu.logout' | translate }}</span>
        </button>
      </nav>
    </div>
  </div>
</div>
